// 小さなチャンクを大量発生させないためにチャンクのグループ化を行っています
// Ref: https://router.vuejs.org/ja/guide/advanced/lazy-loading.html

//モードごとのルート定義リストを作成
function makeRoute(mode){
    const pageList = [
        {pageName:'', component:() => import(/* webpackChunkName: "views" */ './views/PageBasicDialogForm.vue')},
        {pageName:'/basic', component:() => import(/* webpackChunkName: "views" */ './views/PageBasicDialogForm.vue')},
        {pageName:'/cogene', component:() => import(/* webpackChunkName: "views" */ './views/PageCogeneration.vue')},
        {pageName:'/heat-exchanger', component:() => import(/* webpackChunkName: "views" */ './views/PageHeatExchange.vue')},
        {pageName:'/envelope', component:() => import(/* webpackChunkName: "views" */ './views/PageManualBuildingEnvelope.vue')},
        {pageName:'/cooling', component:() => import(/* webpackChunkName: "views" */ './views/PageManualCooling.vue')},
        {pageName:'/heating', component:() => import(/* webpackChunkName: "views" */ './views/PageManualHeating.vue')},
        {pageName:'/hotwater', component:() => import(/* webpackChunkName: "views" */ './views/PageManualHotWaterSystem.vue')},
        {pageName:'/lighting', component:() => import(/* webpackChunkName: "views" */ './views/PageManualLighting.vue')},
        {pageName:'/pv', component:() => import(/* webpackChunkName: "views" */ './views/PageManualPhotovoltaic.vue')},
        {pageName:'/ventilation', component:() => import(/* webpackChunkName: "views" */ './views/PageManualVentilation.vue')},
        {pageName:'/solar', component:() => import(/* webpackChunkName: "views" */ './views/PageSolar.vue')},
        {pageName:'/result', component:() => import(/* webpackChunkName: "views" */ './views/Result.vue')}
    ]
    return pageList.map(function(el){
        const path = '/' + mode + el.pageName
        const name = mode + '/form' + el.pageName
        return {
        path: path,
        name: name,
        component: el.component,
        meta: {mode: mode}
        }
    })
}

export default [
    {
        //利用承諾確認画面
        path: '/',
        name: 'not_agree/confirm',
        component: () => import('./views/Board.vue'),
        meta: { mode: 'all' }
    },
    {
        //404 Not Found
        path: '/404',
        name: '404',
        component: () => import('./views/Board.vue'),
        meta: { mode: 'all' }
    },
    {
        //400 Bad Request
        path: '/400',
        name: '400',
        component: () => import('./views/Board.vue'),
        meta: { mode: 'all' }
    },
    {
        //入力方法選択画面TOP
        path: '/select',
        name: 'selectRoot',
        component: () => import(/* webpackChunkName: "views" */ './views/SelectRoot.vue'),
        meta: { mode: 'all' }
    },
    //簡易入力画面
    {
        path: '/simple',
        name: 'simple/form',
        component: () => import(/* webpackChunkName: "views" */ './views/FormWrapper.vue'),
        meta: { mode: 'simple' }
    },
    {
        path: '/simple/result',
        name: 'simple/result',
        component: () => import(/* webpackChunkName: "views" */ './views/Result.vue'),
        meta: { mode: 'simple' }
    },
    //詳細入力のルート追加
    ...makeRoute('detail'),
    //気候風土のルート追加
    ...makeRoute('trad'),
    //特定事業主基準のルート追加
    ...makeRoute('ees')
]
